import React from 'react';
import { styled } from '@this/src/components/constants/themes';
import type Transit from '@this/src/domain/transit/transit';
import type SelectStore from '../../../../../domain/select_store';
import IndividualDetail from '../short_distance/individual/IndividualDetail';
import PackageDetail from '../short_distance/package/PackageDetail';

interface TransportBoxShortDistanceContainerProps {
  transit: Transit;
  selected: boolean;
  domesticAirPriceIndex: number;
  store: SelectStore;
  isRequestForm?: boolean;
  handleChange: () => void;
}

const TransportBoxShortDistanceContainer: React.FC<TransportBoxShortDistanceContainerProps> = ({
  transit,
  selected,
  domesticAirPriceIndex,
  handleChange,
  store,
  isRequestForm
}) => {
  return (
    <StyledBoxShortDistance selected={selected}>
      {transit.segments.map((segment, i) => {
        return transit.package ? (
          <PackageDetail
            key={i.toString()}
            transport={transit}
            selected={selected}
            handleChange={handleChange}
            store={store}
            isRequestForm={isRequestForm}
            segment={segment}
            segmentIdx={i}
          />
        ) : (
          <IndividualDetail
            key={i.toString()}
            transit={transit}
            selected={selected}
            domesticAirPriceIndex={domesticAirPriceIndex}
            handleChange={handleChange}
            store={store}
            isRequestForm={isRequestForm}
            segment={segment}
            segmentIdx={i}
          />
        );
      })}
    </StyledBoxShortDistance>
  );
};

const StyledBoxShortDistance = styled.div<{ selected: boolean }>`
  display: flex;
  background: white;
  margin-bottom: 10px;
  font-size: 10px;

  ${props =>
    props.selected &&
    `
    border: 2px solid #eee;
    border-color: ${props.theme.linkColor}
  `};
`;

export default TransportBoxShortDistanceContainer;
